import { AfterContentInit, Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { detect } from 'detect-browser';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { ENavigationErrorType } from './model/enum/navigation-error-type';
import { ENavigationRoute } from './model/enum/navigation-route';
import { CoreData } from './tools/core-data/core-data';
import { LoadingTask } from './tools/ui/loading-task';

const browser = detect();

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements AfterContentInit {

    title = 'GS Planning';
    PageHeight!: string;
    Overflow!: string;
    Opacity = 0;

    constructor(
        private route: ActivatedRoute,
        private loadingTask: LoadingTask,
        private router: Router,
        private coreData: CoreData) {
    }

    ngAfterContentInit(): void {
        this.PageHeight = `calc(100% - 80px)`;
        this.Overflow = 'auto';

        if (browser && browser.name === 'ie') {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.IE }]);
        }

        this.loadingTask.LoadingEmitter.subscribe(x => {
            if (x) {
                this.Opacity = 100;
            } else {
                this.Opacity = 0;
            }
        });
    }

    // updateHeight(event: any) {
    //     this.Overflow = 'hidden';
    //     setTimeout(() => {
    //         this.PageHeight = `calc(100% - ${event})`;
    //         this.Overflow = 'auto';
    //     }, 0);
    // }
}
